const DEFAULT_REFRESH_TOKEN_INTERVAL = 3000000; // 50 minutes; 50m * 60s/m * 1000ms/s = 3000000ms

const DEFAULT_INACTIVITY_TIMEOUT = 3600000; // 60 minutes; 60m * 60s/m * 1000ms/s = 3600000ms

const INACTIVITY_DIALOG_GRACE_PERIOD = DEFAULT_INACTIVITY_TIMEOUT; // 60 minutes; 60m * 60s/m * 1000ms/s = 3600000ms

export { DEFAULT_REFRESH_TOKEN_INTERVAL, DEFAULT_INACTIVITY_TIMEOUT, INACTIVITY_DIALOG_GRACE_PERIOD };
